import { watchSaveDetails } from './saveListingDetailsSaga';
import { watchSaveRules } from './saveListingRuleSaga';

const MerchandisingSagas = [watchSaveDetails(), watchSaveRules()];

export default MerchandisingSagas;
